import { Injectable } from "@angular/core";

@Injectable()
export class ThermalAuth {

    private baseUrlThermal = 'baseUrlThermal';

    constructor(

    ) { }

    setBaseUrlThermal(url: string) {
        localStorage.setItem(this.baseUrlThermal, url);
        return true;
    }

    getBaseUrlThermal() {
        return localStorage.getItem(this.baseUrlThermal);
    }

}


// WEBPACK FOOTER //
// ./src/shared/thermal/thermal-auth.ts